// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chart_chartContainer__tWEJk {
  height: 100%;
  width: 100%;
}

.Chart_landingCards__4Fsb8 {
  margin: 16px 0 24px;
}

.Chart_landingCard__lk9OJ {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Chart_landingCardTitle__Suzkm {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
}

.Chart_landingCardBody__3HjyU {
  font-size: 0.9rem;
  color: var(--color-text-muted);
  flex: 1 1;
}

.Chart_landingCardButton__evne- {
  align-self: flex-start;
  background: var(--color-accent);
  color: var(--color-text);
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.85rem;
  cursor: pointer;
}

.Chart_landingCardButton__evne-:hover {
  opacity: 0.9;
}


.Chart_chartTitle__FnykP {
  font-size: 1.5em;
  margin-top: 10px;
/*   padding: 10px; */
}

.Chart_settingsTitle__vUN-e {
  font-size: 1.25em;
  font-weight: bold;
  margin-top: 10px;
/*   padding: 10px; */
}

/* .slider {
  padding: 20px;
  margin-bottom: 100px;
} */

/* Media query for mobile screens */
@media (max-width: 768px) {
  .Chart_chartTitle__FnykP {
    margin-top: 2px;
    font-size: 1.0em;
  }
}

.Chart_slider__O6giI {
  width: 100%;
  height: 8px;
  background: var(--color-border);
  border-radius: 4px;
  position: relative;
  margin-bottom: 20px;
}

.Chart_thumb__zXs3i {
  height: 20px;
  width: 20px;
  background: var(--color-accent);
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.Chart_track__hZuSi {
  background: var(--color-border);
  border-radius: 4px;
}

.Chart_track-1__1bAm5 {
  background: var(--color-accent);
}


.Chart_mark__3RoSA {
  width: 8px; /* Mark size */
  height: 8px;
  background: var(--color-border); /* Mark color */
  border-radius: 50%; /* Make marks circular */
  position: absolute;
  transform: translate(-50%, -50%); /* Center marks */
}

.Chart_mark-active__sBehG {
  background: var(--color-accent); /* Active mark color */
}



.Chart_summaryContainer__YsvUq,
.Chart_retracedPointsContainer__3OjR9 {
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.Chart_summaryContainer__YsvUq h3,
.Chart_retracedPointsContainer__3OjR9 h3 {
  margin: 0;
  font-size: 1.2em;
}

.Chart_summaryContainer__YsvUq ul,
.Chart_retracedPointsContainer__3OjR9 ul {
  list-style: none;
  padding: 0;
}

.Chart_summaryContainer__YsvUq ul li,
.Chart_retracedPointsContainer__3OjR9 ul li {
  margin: 5px 0;
}

.Chart_loading__6cucb {
  text-align: center;
  font-size: 1.2em;
  margin-top: 50px;
}

.Chart_fetchButton__Bs2cU {
  padding: 10px 20px;
  font-size: 16px;
  background-color: var(--color-accent);
  color: var(--color-text);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.Chart_fetchButton__Bs2cU:disabled {
  background-color: var(--color-border);
  cursor: not-allowed;
}

.Chart_error__IVJUR {
  color: var(--color-danger);
  font-size: 14px;
  margin-top: 10px;
}


.Chart_createModelSection__dzcOW {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem; /* Space between dropdown and button */
}

.Chart_createModelSection__dzcOW button {
  background-color: var(--color-bg-header); /* Primary button color */
  color: var(--color-text);
  border: none;
  border-radius: 5px;
  padding: 0.75rem 1.5rem; /* Add padding for better size */
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease; /* Smooth hover effect */
}

.Chart_createModelSection__dzcOW button:disabled {
  background-color: var(--color-border)ccc; /* Disabled state color */
  cursor: not-allowed;
}

.Chart_createModelSection__dzcOW button:hover:not(:disabled) {
  background-color: var(--color-accent); /* Darker shade for hover effect */
}

.Chart_createModelSection__dzcOW p {
  font-size: 0.9rem;
  color: var(--color-success); /* Success message color */
  margin: 0;
}

@keyframes Chart_spin__u227I {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Chart_modalHeader__J4dhZ {
  background-color: var(--color-accent);
  color: var(--color-text);
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.Chart_modalBody__Sts3q {
  padding: 20px;
  font-size: 16px;
  line-height: 1.6;
}

p {
  margin-bottom: 10px;
}

.Chart_sliderLabel__6u65x {
  font-size: 16px; /* Default font size for desktop */
  font-weight: bold; /* Makes the label text bold */
  color: var(--color-text); /* Dark gray color for better visibility */
  margin-bottom: 10px; /* Adds spacing below the label */
  display: block; /* Ensures the label spans the full width */

  /* Responsive styling for smaller screens */
  @media (max-width: 768px) {
    font-size: 14px; /* Smaller font size for tablets and mobile devices */
  }

  @media (max-width: 480px) {
    font-size: 10px; /* Further reduce font size for small mobile devices */
  }
}
.Chart_label__mIl4B {
  margin: 1rem 0;
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: var(--color-bg-header);
  position: relative; /* Position the label within the column */
  bottom: 0; /* Align to the bottom of the column */
}








`, "",{"version":3,"sources":["webpack://./src/components/Chart/Chart.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,SAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;AAClB,qBAAqB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB,qBAAqB;AACrB;;AAEA;;;GAGG;;AAEH,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,UAAU,EAAE,cAAc;EAC1B,WAAW;EACX,+BAA+B,EAAE,eAAe;EAChD,kBAAkB,EAAE,wBAAwB;EAC5C,kBAAkB;EAClB,gCAAgC,EAAE,iBAAiB;AACrD;;AAEA;EACE,+BAA+B,EAAE,sBAAsB;AACzD;;;;AAIA;;EAEE,uCAAuC;EACvC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAE,sCAAsC;AACnD;;AAEA;EACE,wCAAwC,EAAE,yBAAyB;EACnE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB,EAAE,gCAAgC;EACzD,eAAe;EACf,eAAe;EACf,sCAAsC,EAAE,wBAAwB;AAClE;;AAEA;EACE,wCAAwC,EAAE,yBAAyB;EACnE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC,EAAE,kCAAkC;AAC3E;;AAEA;EACE,iBAAiB;EACjB,2BAA2B,EAAE,0BAA0B;EACvD,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,kCAAkC;EACnD,iBAAiB,EAAE,8BAA8B;EACjD,wBAAwB,EAAE,0CAA0C;EACpE,mBAAmB,EAAE,iCAAiC;EACtD,cAAc,EAAE,2CAA2C;;EAE3D,2CAA2C;EAC3C;IACE,eAAe,EAAE,qDAAqD;EACxE;;EAEA;IACE,eAAe,EAAE,sDAAsD;EACzE;AACF;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB,EAAE,yCAAyC;EAC7D,SAAS,EAAE,sCAAsC;AACnD","sourcesContent":[".chartContainer {\n  height: 100%;\n  width: 100%;\n}\n\n.landingCards {\n  margin: 16px 0 24px;\n}\n\n.landingCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.landingCardTitle {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.landingCardBody {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n  flex: 1;\n}\n\n.landingCardButton {\n  align-self: flex-start;\n  background: var(--color-accent);\n  color: var(--color-text);\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.landingCardButton:hover {\n  opacity: 0.9;\n}\n\n\n.chartTitle {\n  font-size: 1.5em;\n  margin-top: 10px;\n/*   padding: 10px; */\n}\n\n.settingsTitle {\n  font-size: 1.25em;\n  font-weight: bold;\n  margin-top: 10px;\n/*   padding: 10px; */\n}\n\n/* .slider {\n  padding: 20px;\n  margin-bottom: 100px;\n} */\n\n/* Media query for mobile screens */\n@media (max-width: 768px) {\n  .chartTitle {\n    margin-top: 2px;\n    font-size: 1.0em;\n  }\n}\n\n.slider {\n  width: 100%;\n  height: 8px;\n  background: var(--color-border);\n  border-radius: 4px;\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.thumb {\n  height: 20px;\n  width: 20px;\n  background: var(--color-accent);\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.track {\n  background: var(--color-border);\n  border-radius: 4px;\n}\n\n.track-1 {\n  background: var(--color-accent);\n}\n\n\n.mark {\n  width: 8px; /* Mark size */\n  height: 8px;\n  background: var(--color-border); /* Mark color */\n  border-radius: 50%; /* Make marks circular */\n  position: absolute;\n  transform: translate(-50%, -50%); /* Center marks */\n}\n\n.mark-active {\n  background: var(--color-accent); /* Active mark color */\n}\n\n\n\n.summaryContainer,\n.retracedPointsContainer {\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  padding: 10px;\n  margin-bottom: 20px;\n  border-radius: 5px;\n}\n\n.summaryContainer h3,\n.retracedPointsContainer h3 {\n  margin: 0;\n  font-size: 1.2em;\n}\n\n.summaryContainer ul,\n.retracedPointsContainer ul {\n  list-style: none;\n  padding: 0;\n}\n\n.summaryContainer ul li,\n.retracedPointsContainer ul li {\n  margin: 5px 0;\n}\n\n.loading {\n  text-align: center;\n  font-size: 1.2em;\n  margin-top: 50px;\n}\n\n.fetchButton {\n  padding: 10px 20px;\n  font-size: 16px;\n  background-color: var(--color-accent);\n  color: var(--color-text);\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.fetchButton:disabled {\n  background-color: var(--color-border);\n  cursor: not-allowed;\n}\n\n.error {\n  color: var(--color-danger);\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n\n.createModelSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem; /* Space between dropdown and button */\n}\n\n.createModelSection button {\n  background-color: var(--color-bg-header); /* Primary button color */\n  color: var(--color-text);\n  border: none;\n  border-radius: 5px;\n  padding: 0.75rem 1.5rem; /* Add padding for better size */\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease; /* Smooth hover effect */\n}\n\n.createModelSection button:disabled {\n  background-color: var(--color-border)ccc; /* Disabled state color */\n  cursor: not-allowed;\n}\n\n.createModelSection button:hover:not(:disabled) {\n  background-color: var(--color-accent); /* Darker shade for hover effect */\n}\n\n.createModelSection p {\n  font-size: 0.9rem;\n  color: var(--color-success); /* Success message color */\n  margin: 0;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.modalHeader {\n  background-color: var(--color-accent);\n  color: var(--color-text);\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.modalBody {\n  padding: 20px;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\np {\n  margin-bottom: 10px;\n}\n\n.sliderLabel {\n  font-size: 16px; /* Default font size for desktop */\n  font-weight: bold; /* Makes the label text bold */\n  color: var(--color-text); /* Dark gray color for better visibility */\n  margin-bottom: 10px; /* Adds spacing below the label */\n  display: block; /* Ensures the label spans the full width */\n\n  /* Responsive styling for smaller screens */\n  @media (max-width: 768px) {\n    font-size: 14px; /* Smaller font size for tablets and mobile devices */\n  }\n\n  @media (max-width: 480px) {\n    font-size: 10px; /* Further reduce font size for small mobile devices */\n  }\n}\n.label {\n  margin: 1rem 0;\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n  color: var(--color-bg-header);\n  position: relative; /* Position the label within the column */\n  bottom: 0; /* Align to the bottom of the column */\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `Chart_chartContainer__tWEJk`,
	"landingCards": `Chart_landingCards__4Fsb8`,
	"landingCard": `Chart_landingCard__lk9OJ`,
	"landingCardTitle": `Chart_landingCardTitle__Suzkm`,
	"landingCardBody": `Chart_landingCardBody__3HjyU`,
	"landingCardButton": `Chart_landingCardButton__evne-`,
	"chartTitle": `Chart_chartTitle__FnykP`,
	"settingsTitle": `Chart_settingsTitle__vUN-e`,
	"slider": `Chart_slider__O6giI`,
	"thumb": `Chart_thumb__zXs3i`,
	"track": `Chart_track__hZuSi`,
	"track-1": `Chart_track-1__1bAm5`,
	"mark": `Chart_mark__3RoSA`,
	"mark-active": `Chart_mark-active__sBehG`,
	"summaryContainer": `Chart_summaryContainer__YsvUq`,
	"retracedPointsContainer": `Chart_retracedPointsContainer__3OjR9`,
	"loading": `Chart_loading__6cucb`,
	"fetchButton": `Chart_fetchButton__Bs2cU`,
	"error": `Chart_error__IVJUR`,
	"createModelSection": `Chart_createModelSection__dzcOW`,
	"modalHeader": `Chart_modalHeader__J4dhZ`,
	"modalBody": `Chart_modalBody__Sts3q`,
	"sliderLabel": `Chart_sliderLabel__6u65x`,
	"label": `Chart_label__mIl4B`,
	"spin": `Chart_spin__u227I`
};
export default ___CSS_LOADER_EXPORT___;
